import {
    FETCH_SCHEMES_PLAN_SUBOPTION_REQUEST,
    FETCH_SCHEMES_PLAN_SUBOPTION_SUCCESS,
    FETCH_SCHEMES_PLAN_SUBOPTION_FAILURE,
  } from "./FetchMedSchemePlanSubOptionsTypes";
  import api from "../../utils/Api";
  
  export const fetchSchemesPlanSubOptionsRequest = () => {
    return {
      type: FETCH_SCHEMES_PLAN_SUBOPTION_REQUEST,
    };
  };
  
  export const fetchSchemesPlanSubOptionsSuccess = (schemesPlanOptions) => {
    return {
      type: FETCH_SCHEMES_PLAN_SUBOPTION_SUCCESS,
      payload: schemesPlanOptions,
    };
  };
  
  export const fetchSchemesPlanSubOptionsFailure = (error) => {
    return {
      type: FETCH_SCHEMES_PLAN_SUBOPTION_FAILURE,
      payload: error,
    };
  };
  
  export const fetchMedSchemesPlanSubOptions = (plan_option_code) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    return async (dispatch) => {
      dispatch(fetchSchemesPlanSubOptionsRequest);
      try {
        const response = await api.get(
          "relatedparty/schemes/plansuboption/autocomplete?plan_option_code=" + plan_option_code,
          {
            headers: headers,
          }
        );
  
        const schemesPlanSubOptions = response.data.data;
        //console.log("******* patient autocomplete - ", patient);
        dispatch(fetchSchemesPlanSubOptionsSuccess(schemesPlanSubOptions));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchSchemesPlanSubOptionsFailure(errorMsg));
      }
    };
  };
  